export default {
  domain: '3d-img-dl-dev.jp.auth0.com',
  clientId: 'dVIElYkMzBfF0BwY8cZmGn7CpLn24Wec',
  audience: 'https://api.dev.digifab.stylem.co.jp',
  scope: 'get_download_token:3d download_history_list:3d read:fabric read_list:fabric read:customer',
  redirectUri: 'https://dev.digifab.stylem.co.jp/callback/login',
  logoutUri: 'https://dev.digifab.stylem.co.jp/callback/logout'
}
